import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Splat + query-preserving client redirect (PRO-0440 / SF-002). Used to re-home
 * the retired `/admin/templates/*` deep links onto `/settings/templates/*` without
 * dropping the trailing segment or the query string.
 *
 * Preserves both the splat and the search string:
 * - `/admin/templates/:id`             -> `/settings/templates/:id`
 * - `/admin/templates/new`             -> `/settings/templates/new`
 * - `/admin/templates/:id?tab=content` -> `/settings/templates/:id?tab=content`
 *   (the TemplateCreateWizard deep link relies on `?tab=content`; dropping the
 *   query would land the redirect on the wrong tab).
 *
 * The target route is itself guarded (`L6_PLATFORM_ADMIN`), so the redirect
 * resolves through the guard, never around it.
 */
export function RedirectSplat({ to }: { to: string }) {
  const params = useParams();
  const { search } = useLocation();
  const splat = params['*'] ?? '';
  const base = splat ? `${to}/${splat}` : to;
  return <Navigate to={`${base}${search}`} replace />;
}
